import React from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/app';
import 'firebase/analytics';
import { useLocation } from 'react-router-dom';

let tracker;
export function init(config = {}) {
  const firebaseConfig = {
    apiKey: config.apiKey,
    projectId: config.projectId,
    appId: config.appId,
    measurementId: config.measurementId,
  };

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
    firebase.analytics();
  }

  tracker = firebase;
}

const defaultOptions = {};

function removeFirstSlash(string) {
  if (string.charAt(0) === '/') return string.slice(1);
  return string;
}

function trackPageLocation(pathname, options) {
  // removes all uuids from the pathname
  let screenName = pathname.replace(/\/\b[a-f\d-]{36}/g, '');
  screenName = removeFirstSlash(screenName);

  tracker.analytics().logEvent('page_view', {
    ...options,
    page_title: screenName,
  });
}

export const withAnalytics = (WrappedComponent, options = defaultOptions) => {
  const HOC = (props) => {
    React.useEffect(() => {
      trackPageLocation(props.location.pathname, options);
    }, [props.location.pathname]);
    return <WrappedComponent {...props} />;
  };

  HOC.propTypes = {
    location: PropTypes.object,
  };

  return HOC;
};

export function useAnalytics(options = defaultOptions) {
  const location = useLocation();

  React.useEffect(() => {
    trackPageLocation(location.pathname, options);
  }, [location.pathname, options]);
}

export const trackAnalyticsEvent = (eventName, options) => {
  firebase.analytics().logEvent(eventName, options);
};
